import type { ModeToggleProps } from './types';

export const ModeToggle = ({
  options,
  activeValue,
  onChange,
  hint,
}: ModeToggleProps) => {
  const base =
    'flex-1 py-2 text-[13px] font-semibold cursor-pointer border transition-colors';
  const active = 'bg-[#161b22] text-[#58a6ff] border-[#58a6ff]';
  const inactive =
    'bg-[#21262d] text-[#8b949e] border-[#30363d] hover:text-[#c9d1d9]';

  return (
    <div>
      <div className="flex gap-0 mb-2">
        {options.map((opt, i) => {
          const isFirst = i === 0;
          const isLast = i === options.length - 1;
          const rounded = isFirst
            ? 'rounded-l-md'
            : isLast
              ? 'rounded-r-md'
              : '';
          return (
            <button
              key={opt.value}
              className={`${base} ${rounded} ${opt.value === activeValue ? active : inactive}`}
              onClick={() => onChange(opt.value)}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
      <div className="text-[12px] text-[#8b949e]">{hint}</div>
    </div>
  );
};
